import { useSearchParams } from "react-router-dom";
import { Modal } from "../../../components/others/Modal/index";
import Fillpromotion from "./Fillpromotion";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  onClose?: Function;
};

const Promotion = ({ toggleModal, urlTittle, onClose }: TProps) => {
  const [searchParams, setSearchParams] = useSearchParams("");
  const candidates = searchParams.get("candidates")?.split(",") || [];
  const name = searchParams.get("name") || [];

  const styles = "text-xl text-center font-bold m-5";
  const title =
    candidates.length === 1
      ? `¿Seguro queres promover a ${name}?`
      : `¿Seguro queres promover a los postulantes seleccionados (${candidates.length})?`;

  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={title}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={() => onClose?.()}
      >
        <Fillpromotion />
      </Modal>
    </>
  );
};

export default Promotion;
